import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class ConfigurableDateAdapter extends NativeDateAdapter {
	parse(dateString: any): Date | null {
		if ((typeof dateString === 'string') && (dateString.includes('/') || dateString.includes('-'))) {
			// using hardcoded European format for now. Improve later.
			const splitter = dateString.includes('/') ? '/' : '-';
			const [date, month1, year] = dateString.split(splitter).map(s => Number(s));
			const month = month1 - 1;

			if (month > 11) {
				return null;
			}

			return new Date(year, month, date);
		} else {
			return new Date(dateString);
		}
	}
	getFirstDayOfWeek(): number {
		return 1;
	}
}
